
import type { ComponentProps, CSSProperties } from 'react'

import cx from 'classnames'
import { MdDelete, MdDeleteOutline } from 'react-icons/md'

import tableStyles from '../../claim-history/simple-table/table.module.css'

import styles from './material-delete-button.module.css'

interface Props extends ComponentProps<'button'>{
  onClick: () => void
  title?: string
  style?: CSSProperties
  inTable?: boolean
}

export function MaterialDeleteButton ({ onClick, className, title, inTable = true, ...rest }: Props): JSX.Element {
  return (
    <button
      type='button'
      title={title ?? 'Delete'}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        onClick?.()
      }}
      className={cx(
        inTable && tableStyles.actionButton,
        styles.actionButton,
        className,
        'cursor-pointer'
      )}
      {...rest}
    >
      <MdDelete
        className={styles.trashIconFilled}
        color='#7A7A7A'
        size='1.4rem'
      />
      <MdDeleteOutline
        className={styles.trashIconOutlined}
        color='#7A7A7A'
        size='1.4rem'
      />
    </button>
  )
}
